// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith#Polyfill
export default function startsWith(str, search, pos) {
	pos = !pos || pos < 0 ? 0 : +pos;
	return str.substring(pos, pos + search.length) === search;
}
